import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";
import { EBetSplit, IRoundPayout } from "../interfaces";

@Injectable()
export class CashOutUseCase implements IUseCase<{ betIndex: number, roundId: string, isAutoStop?: boolean }, Promise<IRoundPayout | void>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(args: { betIndex: number, roundId: string, split: EBetSplit, isAutoStop?: boolean }): Promise<IRoundPayout | void> {
        return this.roundRepository.cashOut(args.betIndex, args.roundId, args.split, args.isAutoStop);
    }
}
